<template>
  <div>
    <div class="layout">
      <Menu active-key="1" @on-select="onSelect">
        <Menu-group title="业务介绍">
          <Menu-item key="1" name="one">
            1. 商户名称及标识
          </Menu-item>
          <Menu-item key="2" name="two">
            2. 商品或服务描述
          </Menu-item>
          <Menu-item key="3" name="three">
            3. 网上交易流程描述
          </Menu-item>
          <Menu-item key="4" name="four">
            4. 消费者客户服务联系方式
          </Menu-item>
          <Menu-item key="5" name="five">
            5. 退貨、退款和交易取消政策
          </Menu-item>
          <Menu-item key="6" name="six">
            6. 退货政策
          </Menu-item>
          <Menu-item key="7" name="seven">
            7. 交易货币及支付方式（如支付宝，微信等）
          </Menu-item>
          <Menu-item key="8" name="eight">
            8. 售后服务或纠纷处理方式
          </Menu-item>
          <Menu-item key="9" name="nine">
            9. 保密声明或隐私声明政策
          </Menu-item>
        </Menu-group>
      </Menu>
      <content class="content">
        <h2 id="one">1. 商户名称及标识</h2>
        <div class="denomination">
          <div class="title">元芝庄药业有限公司</div>
          <div><img src="/assets/pc/images/home/live-logo.jpg" alt="" /></div>
        </div>
        <h2 id="two">2. 商品或服务描述</h2>
        <div>
          元芝庄药业目标成为国内最大的药品线上商城
        </div>
        <h2 id="three">3. 网上交易流程描述</h2>
        <div>
          先登录帐户，把药品加入购买界面，在购买页面中确认信息。如果是处方药，需要药剂师进行审核，审核通过后，客服会联系顾客到店取药。如果是非处方药，选择付款方式：微信支付，余额支付，线下支付，点击确认付款，成功付款后，商家会根据顾客的需求进行发货。
        </div>
        <h2 id="four">4. 消费者客户服务联系方式</h2>
        <div>
          <p>联系电话：0592-5911769</p>
          <p>地址：厦门市思明区侨洪里26号之三</p>
        </div>
        <h2 id="five">5. 退貨、退款和交易取消政策</h2>
        <div>
          <p>
            取消订单：当您的订单完成付款后，相关订单内容已经被商户确认并发货，我们无法为您取消订单内容。
          </p>
          <p>退货：当您的订单一经发货并已在运输途中后，我们不提供退货。</p>
          <p>
            退款：当您的订单在发货前，发现有任何问题，可以在订单处发起退款申请或当您的订单被执业药师审核不通过，我们会直接更换。
          </p>
        </div>
        <h2 id="six">6. 送货政策</h2>
        <div>
          <p>（1）到店自提。</p>
          <p>（2）由商家用普通快递邮寄。</p>
        </div>
        <h2 id="seven">7. 交易货币及支付方式（如微信，支付宝等）</h2>
        <div>
          <p>交易货币：人民币</p>
          <p>支付方式：微信支付，余额支付，线下支付</p>
        </div>
        <h2 id="eight">8. 售后服务或纠纷处理方式</h2>
        <div>
          <p>售后服务或纠纷处理可通过微信、QQ、Email或致电联系电话处理。</p>
        </div>
        <h2 id="nine">9. 保密声明或隐私声明政策</h2>
        <div>
          <p>
            元芝庄药业有限公司（以下简称为本公司或元芝庄）根据任何使用本公司PC端页面的人员的私隐权。我们会确保所收集的个人资料仅用于资料审核，我们对个人资料进行保密，对提供的资质材料进行用完即毁，不用作一切商业行为。
          </p>
        </div>
      </content>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelpCenter",
  data() {
    return {};
  },
  methods: {
    onSelect(name) {
      document.querySelector("#" + name).scrollIntoView();
    }
  }
};
</script>

<style lang="stylus" scoped>
.layout
  display flex
  background #fff
  .content
    margin 0 20px
    padding-bottom 20px
    width 100%
    font-size 16px
    .denomination
      text-align center
      .title
        font-size 14px
    div
      font-size 14px
    h2
      margin-top 20px
</style>
